import { ClientModel } from "./client-model";

export const Model: ClientModel = new ClientModel();
